import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

const Accord = ({ title, text, obj , setSelectionOption, selectionOptions = {} }) => {

    // console.log(text, selectionOptions);
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const optionSelect = (e, option, item) =>{
        setSelectionOption(item.key,item.value);
    };

    return (
        // <div className="container">
        <div className="row">
            <div className="wrapper">
                <div className={isOpen ? "open" : ""} onClick={toggle}>
                    <div className="title">
                        {title} <span className={isOpen ? "arrow-dw" : "arrow"}>
                            <i className="fa fa-angle-down"></i></span>
                    </div>
                </div>
                <Collapse isOpen={isOpen}>
                    {Object.values(text).map((item, i) => {
                        // console.log(selectionOptions,selectionOptions?.hasOwnProperty(item.key), item.key, selectionOptions[item.key], item.value)
                        const checked = selectionOptions?.hasOwnProperty(item.key) ? selectionOptions[item.key] === item.value : false;

                        return (
                                <p className="menuLink" key={i}>
                                    <label className="form-check-label  checkboxLabel">
                                        <input type="radio" className="form-check-input" data-dd={checked} data-key={item.key} checked={checked} onChange={(e)=>optionSelect(e, obj, item)} name={title} value={item?.menu} />
                                        &nbsp;{item?.menu}</label>
                                </p>
                        )
                    })}

                </Collapse>
                <hr />
            </div>
        </div>
        // </div>
    );
}

export default Accord